/* eslint-disable camelcase */
import React, { Component } from 'react';

import propTypes from 'prop-types';
import Classes from './NextSongItem.css';

class NextSongItem extends Component {
  render() {
    let trendClassName = Classes.CardPositive;
    let trendArrow = 'up-arrow.svg';

    if (this.props.trend === 'negative') {
      trendClassName = Classes.CardNegative;
      trendArrow = 'down-arrow.svg';
    }

    let userPicture = '';
    if (!this.props.pictureUser) {
      userPicture = '.';
    } else {
      userPicture = this.props.pictureUser;
    }

    return (
      <div className={[trendClassName, 'row', Classes.NoSpace].join(' ')}>
        {/** Song Picture */}
        <div className="col-md-2">
          <img
            src={`${this.props.songImage}?auto=compress&cs=tinysrgb`}
            className={[Classes.SongImage, 'img-responsive'].join(' ')}
            alt={this.props.songName}
            title={this.props.songName}
          />
        </div>
        {/** Song Title & Description */}
        <div className="col-md-5">
          <p className={Classes.SongTitle}>
            {this.props.songName}
          </p>
          <p className={Classes.SongDescription}>
            {this.props.songAuthor}
          </p>
        </div>
        {/** Score */}
        <div className={['col-md-2', 'd-flex', 'align-items-center'].join(' ')}>
          <img
            src={require(`../../../assets/img/${trendArrow}`)}
            className={[Classes.ScoreIcon, 'img-responsive'].join(' ')}
            alt="Score Item"
            title="Score Item"
          />
        </div>
        { /** User image */}
        {
        userPicture[0] === '.' 
          ? (
            <div className={[Classes.TxtCenter, 'col-3'].join(' ')}>
              <img
                src={require('../../../assets/svg/anon-user.svg')}
                className={[Classes.SongUserAnon, 'img-responsive'].join(' ')}
                alt="User"
                title="User"
              />
            </div>
          ) : (
            <div className={[Classes.TxtCenter, 'col-3'].join(' ')}>
              <img 
                src={`${userPicture}`}
                className={[Classes.SongUser, 'img-responsive'].join(' ')}
                alt="User"
                title="User"
              />
            </div>
          )
        }
      </div>
    );
  }
}

/** --- PROPS TYPE VALIDATION --- */
NextSongItem.propTypes = {
  songImage: propTypes.string.isRequired,
  songName: propTypes.string.isRequired,
  trend: propTypes.string.isRequired,
  pictureUser: propTypes.string.isRequired,
  songAuthor: propTypes.string.isRequired
};
/** --- END VALIDATION --- */

export default NextSongItem;
